import { RoomGroupType } from '../../../../system/rooms';

export type ExpandedState = Record<string, boolean>;

export interface DragItem {
  key: string;
  index: number;
  itemNumber: number;
}

// Base room groups (always shown)
const BASE_ROOM_GROUPS: RoomGroupType[] = [
  {
    label: 'Bedroom',
    type: 'Bedroom',
  },
  {
    label: 'Full Bathroom',
    type: 'Bathroom',
    groupWith: ['Full Bath'],
  },
  {
    label: 'Half Bathroom',
    type: 'Half Bath',
  },
];

// Laundry room group (shown when feature flag is enabled)
const LAUNDRY_ROOM_GROUP: RoomGroupType = {
  label: 'Laundry',
  type: 'Laundry',
};

/**
 * Get room groups based on feature flags
 * @param hasLaundryFeature - Whether the laundry counting feature is enabled
 */
export const getRoomGroups = (hasLaundryFeature: boolean): RoomGroupType[] => {
  if (hasLaundryFeature) {
    return [...BASE_ROOM_GROUPS, LAUNDRY_ROOM_GROUP];
  }
  return BASE_ROOM_GROUPS;
};

// Keep RoomGroups for backward compatibility (without laundry)
export const RoomGroups: RoomGroupType[] = BASE_ROOM_GROUPS;
